//@flow

function getWorkEmailPattern() {
  const domainsNotAllowed = ["hotmail", "gmail", "ymail", "googlemail", "live", "gmx",
    "yahoo", "outlook", "msn", "icloud", "facebook", "aol", "zoho", "mail", "yandex",
    "hushmail", "lycox", "lycosmail", "inbox", "myway", "aim", "fastmail", "goowy",
    "juno", "shortmail", "atmail", "protonmail"];
  const pattern = domainsNotAllowed.map((domain) => {
    return [...domain].map(ch => `[${ch}${ch.toUpperCase()}]`).join('');
  }).join('|');
  return "\\w+[-\\.\\w]*@(?!(?:" + pattern + ")\\.[Cc][Oo][Mm]$)\\w+[-\\.\\w]*?\\.\\w{2,4}";
}

export default {
  getWorkEmailPattern,
};
